module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "courselist"
  }, [_c('div', {
    staticClass: "banner_container"
  }, [_c('div', {
    staticClass: "banner_title"
  }, [_vm._v(_vm._s(this.$route.query.name))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("@/assets/images/listitem/国外影城一瞥- banner (1).png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "star_list"
  }, [(_vm.ItemData.length) ? _vm._l((_vm.ItemData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "star_list_item",
      on: {
        "click": function($event) {
          return _vm.itemClickFun(item)
        }
      }
    }, [_c('div', {
      staticClass: "star_list_item_pic"
    }, [(item.pics.length == 0) ? _c('img', {
      attrs: {
        "src": "#",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": item.pics[0].url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_decs"
    }, [_vm._v("\n            " + _vm._s(item.desc) + "\n          ")])])
  }) : _c('img', {
    staticClass: "list_empty_img_class",
    attrs: {
      "src": require("@/assets/images/listitem/course_constuct.png")
    }
  })], 2)]), _vm._v(" "), _c('DeBounce', {
    attrs: {
      "fetch-fun": _vm.getNewsItemlist,
      "pagefetchflag": _vm.pagefetchflag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0718a8ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/ForeignFilm.vue
// module id = 1142
// module chunks = 0